import { styled } from '@mui/material/styles';
import { Typography } from '@mui/material';
import { isDark } from 'global/styles';

export const RowWrap = styled('div')({
  display: 'flex',
  flexWrap: 'nowrap',
  alignItems: 'center',
});

export const RowTop = styled('div')({
  display: 'flex',
  alignItems: 'center',
});

export const CpScoreHeaderChild = styled(Typography)({
  width: 48,
  minWidth: 48,
  textAlign: 'center',
  margin: 0,
});

export const RefLabel = styled('div')(({ theme }) => ({
  fontSize: 12,
  color: theme.palette.text.secondary,
  textFillColor: theme.palette.text.secondary,
}));

export const TagLink = styled('div')(({ theme }) => ({
  marginBottom: theme.spacing(1),
}));

export const TagReference = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  color: isDark(theme) ? theme.palette.common.white : theme.palette.secondary.main,
}));
